<template>
  <div>
    <div
      v-if="clickName==='touchstart'"
      class="choose-mask"
      :style="{opacity:isMask ? 1: 0, zIndex:isMask ? 9999:-99999}"
      @touchstart="cancelMask"
    >
      <ul :class="isMask?'choose-mark mark-appear':'choose-mark mark-none'">
        <li class="choose-operate">
          <p class="opt-reply">Reply</p>
          <p class="opt-report">Report</p>
        </li>
        <li class="choose-cancel" @touchstart="$bus.$emit('toggleMask')">Cancel</li>
      </ul>
    </div>
    <div
      v-else
      class="choose-mask"
      :style="{opacity:isMask ? 1: 0, zIndex:isMask ? 9999:-99999}"
      @click="cancelMask"
    >
      <ul :class="isMask?'choose-mark mark-appear':'choose-mark mark-none'">
        <li class="choose-operate">
          <p class="opt-reply">Reply</p>
          <p class="opt-report">Report</p>
        </li>
        <li class="choose-cancel" @touchstart="$bus.$emit('toggleMask')">Cancel</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isMask: {
      default() {
        return false
      },
      required: false
    },
    clickName: {
      default() {
        return 'touchstart'
      },
      required: true
    }
  },
  methods: {
    cancelMask(e) {
      if (e.target.nodeName === 'DIV') {
        this.$bus.$emit('toggleMask')
      }
      if (e.target.nodeName === 'P') {
        this.$emit('handleOpenApp')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/rem.scss';
.choose-mask {
  position: absolute;
  z-index: 998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s linear;
  -webkit-transition: opacity 0.3s linear;
}
.choose-mark {
  position: absolute;
  left: 0px;
  width: 100%;
  z-index: 999;
  transition: bottom 0.3s linear;
  -webkit-transition: bottom 0.3s linear;
  padding: rem(20px) rem(10px);
  > li {
    width: 100%;
    min-height: rem(50px);
    line-height: rem(50px);
    text-align: center;
    color: rgb(0, 126, 250);
    border-radius: rem(10px);
    background: #fff;
    font-size: rem(14px);
    > p {
      height: rem(50px);
    }
    > p.opt-reply {
      border-bottom: rem(1px) solid rgb(240, 240, 250);
    }
  }
  > .choose-cancel {
    margin-top: rem(8px);
    font-size: rem(15px);
    font-weight: 600;
  }
}
.mark-appear {
  bottom: 0px;
}
.mark-none {
  bottom: rem(-999px);
  display: none;
}
</style>